export default __webpack_public_path__ + "static/Денежный поток 2-70b1243870193be38bc2265510d502d1.jpg";